$('.featured-slider .owl-carousel').owlCarousel({
    loop: true,
    margin: 27,
    dots: false,
    nav: true,
    items: 3.65,
    stagePadding: 2,
    responsive: {
        0: {
            items: 1.1,
            margin:5 
        },
        480: {
            items: 1
        },
        600: {
            items: 1.5,
            margin:10
        },
        768: {
            items: 1.2,
            margin:12
        },
        992: {
            items: 2.2,
            margin:15
        },
        1281: {
            items: 3.2,
            margin:18
        },
        1451: {
            items: 3.4
        },
        1601: {
            items: 3.65
        }
      }
})

$(document).ready(function () {
  var main = $(".product-detail .main-slider");
  var thumbs = $(".product-detail .thumb-slider");

  main.owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    dots: false,
    autoplay: false
  }).on("changed.owl.carousel", syncPosition);

  thumbs.owlCarousel({
    items: 3,
    margin: 25,
    stagePadding: 1,
    dots: false,
    nav: false,
    responsive: {
        0: {
            items: 3,
            margin: 5,
        },
        480: {
            items: 3
        },
        768: {
            items: 4
        },
        1000: {
            items: 3
        }
      }
  });

  function syncPosition(event) {
    var index = event.item.index - event.relatedTarget._clones.length / 2;
    var count = event.item.count;
    if (index < 0) index = count - 1;
    if (index >= count) index = 0;

    thumbs.find(".thumb").removeClass("active").eq(index).addClass("active");
    thumbs.trigger("to.owl.carousel", [index, 300, true]);
  }

  thumbs.on("click", ".thumb", function () {
    var index = $(this).parent().index();
    main.trigger("to.owl.carousel", [index, 300, true]);
  });

  thumbs.find(".thumb").eq(0).addClass("active");
});

//$('#shopify-section-template--19407893037142__section_76jBBY').addClass('tab-pane');

$(document).on("click", ".tab-links .tab-link", function () {
  if ($(this).hasClass("active")) return;

  var tabId = $(this).data("tab");
  var text_tab = $(this).text();

  /*
  if(text_tab =='Review'){
      $('#shopify-section-template--19407893037142__section_76jBBY').addClass("active");
  }else{
    $('#shopify-section-template--19407893037142__section_76jBBY').removeClass("active");
  }
  */

  $(this).siblings().removeClass("active");
  $(this).addClass("active");

  $(this).closest(".tab-wrapper")
         .find(".tab-pane")
         .removeClass("active");

  $("#" + tabId).addClass("active");
});


$(document).on('click', '.mobile-search-icon', function () {
  $('.search-form').addClass('open');
});

$(document).on('click', '.search-close', function () {
  $('.search-form').removeClass('open');
});



// Menu dropdown Mobile
// $(document).ready(function () {
//   $('.menu-drawer__menu--childlist').hide();
//   $('.menu-drawer__menu-item--mainlist').on('click', function (e) {
//     e.preventDefault();
//     var $parentLi = $(this).closest('li');
//     var $submenu = $parentLi.find('.menu-drawer__menu--childlist');
//     $('.menu-drawer__menu--childlist').not($submenu).slideUp();
//     $('.menu-drawer__menu-item--mainlist').not(this).removeClass('open');
//     $submenu.slideToggle();
//     $(this).toggleClass('open');
//   });
// });


$(document).ready(function () {
  setTimeout(function () {
    $('.judgme-custom-wrap').appendTo('#Review');
    /*
    if ($('#Review').length && $('.jdgm-horizon-widget').length) {      
    }
    */
   
  }, 1000);
});